export default "https://assets.egbcdn.net/assets/packs/_/sounds/money_sound-c584002d949dd02371d364b8cf5da7a6.mp3";